import "./style.css";
import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Container from "components/Container";

export default function TextBox({
	textContainerClass,
	textId,
	text,
	textClass,
	textTitle,
	faIcon,
	faIconClass,
}) {
	return (
		<Container
			containerClass={`text-box-container ${textContainerClass}`}
		>
			{faIcon && (
				<FontAwesomeIcon
					icon={faIcon}
					className={`fa-icon-class ${faIconClass}`}
				/>
			)}
			<p
				id={textId}
				className={`text-box ${textClass}`}
				title={textTitle}
			>
				{text}
			</p>
		</Container>
	);
}
